import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "Qualified & accredited", body: "NAPIT approved electricians and Gas Safe registered. Every installation is certified and signed off to current regulations." },
  { n: "02", title: "One team, two trades", body: "Electrical and air conditioning under one roof means joined-up work, fewer contractors and a single point of contact." },
  { n: "03", title: "Tidy, on time, on budget", body: "Clear quotes with no surprises, respectful of your home, and finished to a standard we're proud to put our name on." },
];

export const About = ({ imageUrl }) => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white border-y border-black/10">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="font-display text-xs uppercase tracking-[0.25em] text-brand-blue mb-4">
              01 — Why JD
            </p>
            <h2 className="font-display font-extrabold tracking-tighter text-ink text-5xl lg:text-6xl leading-[0.95]">
              A trade you can actually trust.
            </h2>
            <motion.div
              initial={{ opacity: 0, scale: 1.04 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 rounded-2xl overflow-hidden border border-black/10 aspect-[4/3]"
            >
              <img src={imageUrl} alt="Electrician at work" className="w-full h-full object-cover" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <div className="flex flex-col divide-y divide-black/10">
              {chapters.map((c, i) => (
                <motion.div
                  key={c.n}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="flex gap-8 py-10 first:pt-0"
                  data-testid={`manifesto-chapter-${i}`}
                >
                  <span className="font-display text-6xl font-extrabold text-brand-yellow tracking-tighter leading-none shrink-0">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{c.title}</h3>
                    <p className="font-body text-ink/55 mt-3 text-lg leading-relaxed max-w-lg">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
